/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaProgress/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaProgressTag from './TysiaProgressTag/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaProgress({
  children,
  text,
  isLast,
  disabled,
  tags,
  viewPath = "/DesignSystem/TysiaProgress",
  color
  
}) {
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsGreen600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.600'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtTysiatextColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaText.color.primary.base'
        })
let colorOrdtTysiatextColorPrimaryBase = color ?? dtTysiatextColorPrimaryBase
let colorOrdtTysiatextColorPrimaryBase1 = color ?? dtTysiatextColorPrimaryBase
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaProgress.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="TysiaProgress.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-ZifQiO': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TysiaProgress.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-3-ZifQiO': dtColorsNeutral200,'--bc-2-ZifQiO': disabled ? dtColorsNeutral400 : dtColorsGreen600}}
 className={`views-block ${styles.Vertical1}`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text={text}
 color={disabled ? dtColorsNeutral400 : colorOrdtTysiatextColorPrimaryBase1}
/>
<div
  data-testid="TysiaProgress.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="TysiaProgress.List"
  data-view-path={viewPath}
 style={{'--g-1-ZifQiO': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(tags) && tags.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="tag"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/TysiaProgressTag(${item?.id ?? item?._id ?? index})`}
      >
<TysiaProgressTag
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/TysiaProgressTag(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</div>
</div>
<div
  data-testid="TysiaProgress.Vertical:2"
  data-view-path={viewPath}
 style={{'--bc-2-ZifQiO': dtColorsNeutral300,'--h-4-ZifQiO': isLast ? "0px" : "20px"}}
 className={`views-block ${styles.Vertical2}`}
/>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }